module.exports = __webpack_public_path__ + "static/championships-5f30c761edc839c4d2aa8d06e3b8aff0.svg";